'use strict';

import { assign, map, isEqual, throttle } from 'lodash';

var ComponentUtils = require('./ComponentUtils');
var PropertyUtils = require('./PropertyUtils');

var DomElementUtils = require('../utils/DomElementUtils');
var TextManipulationUtils = require('./TextManipulationUtils');

/** @module PageDomStateTracker
 * @requires lodash
 * @requires ComponentUtils
 * @requires PropertyUtils
 * @requires DomElementUtils
 * @requires TextManipulationUtils
 */
function PageDomStateTracker(element, onchange) {
	var _getProperties = function(component) {
		return PropertyUtils.GetAllPropertiesState(component);
	};

	var _buildComponentState = function(component) {
		return assign(ComponentUtils.GetComponentInfo(component), {
			rect: DomElementUtils.GetElementRect(component),
			properties: _getProperties(component)
		});
	};

	var _getComponents = function() {
		return map(ComponentUtils.GetAllComponents(element), _buildComponentState);
	};

	var _prevState = {};
	var _onchange = function() {
		var state = {
			page: DomElementUtils.GetElementScrollRect(element),
			components: _getComponents(),
			selection: TextManipulationUtils.GetSelectedTextState()
		};
		if(!isEqual(state, _prevState)) {
			onchange(_prevState = state);
		}
	};

	//any dom changes (resize, css @media, client js) trigger this event
	//so we have to throttle update
	_onchange = throttle(_onchange, 100);

	this.setup = function() {
		_onchange();

		this.destroy();

		this.observer = new MutationObserver(_onchange);
		this.observer.observe(element, { childList: true, attributes: true, subtree: true, characterData: true });
	};

	this.destroy = function() {
		if(!this.observer) return;

		this.observer.disconnect();
		this.observer = null;
	};
}

module.exports = PageDomStateTracker;
